<p-dialog
        (onHide)="dialogClosing()"
        [(visible)]="displayPhoneVerification"
        [modal]="true"
        [closable]="true"
        [dismissableMask]="true"
        header="Verify Your Phone Number"
        [style]="{ width: '400px' }"
        [contentStyle]="{ 'padding': '2rem' }">

    <div *ngIf="isPhoneProvided; else phoneNotProvided">
        <div class="text-center text-sm text-color-primary mb-3">
            Let us quickly verify your phone number! We’ll text you a code at {{ phoneToVerify }}.
        </div>
        <!-- Start Verification -->
        <div *ngIf="!codeSent">
            <button
                    pButton
                    label="Send Verification Code"
                    icon="pi pi-send"
                    class="p-button-success w-full"
                    (click)="startPhoneVerification()"
                    [disabled]="isSending"
            ></button>
            <p (click)="codeSent = true" class="text-center mt-3 underline cursor-pointer tn-text-simple tn-text-green">I already have a code</p>
        </div>
        <!-- Code Entry -->
        <div *ngIf="codeSent" class="mt-3 text-center">
            <label class="block mb-2">Enter the code you received:</label>
            <div class="code-input-container mt-3">
                <ngx-otp-input #otpInput
                               (otpChange)="otpChanged($event)"
                               (otpComplete)="submitPhoneCode($event)"></ngx-otp-input>
            </div>
            <div class="flex flex-column justify-content-center align-items-center mt-3">
                <button
                        pButton
                        label="Verify Code"
                        icon="pi pi-check"
                        class="p-button-primary"
                        (click)="submitPhoneCode(otpCode.join(''))"
                        [disabled]="!isOtpCodeFilled()"
                ></button>

                <button
                        pButton
                        label="Resend"
                        class="p-button-link"
                        (click)="startPhoneVerification()"
                        [disabled]="isSending"
                ></button>
            </div>
        </div>
        <!-- Messages -->
        <p-messages [(value)]="verificationMessages" class="mt-3 w-full"></p-messages>
    </div>

    <ng-template #phoneNotProvided>
        <div class="text-center text-sm text-color-primary mb-3">
            To book a studio, your phone number is required:
        </div>
        <div class="text-center m-4 justify-content-center">
            <p-dropdown
                    [options]="countriesData"
                    [(ngModel)]="newPhonePrefix"
                    optionValue="phone"
                    optionLabel="code"
            >
                <ng-template let-code pTemplate="item">
                    <div class="country-code">
                        <span class="flag-icon flag" [ngClass]="'flag-' + code.code.toLowerCase()"></span>
                        <span *ngIf="!isMobile">{{code.label}} (+{{code.phone}})</span>
                        <span *ngIf="isMobile">{{code.code}}</span>
                    </div>
                </ng-template>
            </p-dropdown>
            <p-inputNumber
                    id="newPhoneNumber"
                    inputId="newPhoneNumber"
                    [prefix]="showPhonePrefix()"
                    [maxlength]="16"
                    [useGrouping]="false"
                    [(ngModel)]="newPhoneNumber"
            ></p-inputNumber>
        </div>
      <div class="text-center m-2 justify-content-center">
        <button
                pButton
                label="Save"
                icon="pi pi-save"
                class="tn-primary-button text-center m-2"
                (click)="saveNewPhoneNumber()"
                [disabled]="loading"
        ></button>
      </div>
    </ng-template>
</p-dialog>
